import React from 'react';

import { Grid, Container } from '@material-ui/core/';
import { BsFolderCheck, BsColumnsGap, BsGrid3X3 } from 'react-icons/bs';

import events_vector from '../../assets/images/events_vector.svg';

import Sidebar from '../../components/SideBar';
import Label from '../../components/Label';

import {
    Align
} from './styles';

const Home = () => {
    const page = (
        <>
            <Container>
                <Grid container justify="space-around" spacing={8}>
                    <Grid item xs={12} sm={6} md={6}>
                        <Align>
                            <BsGrid3X3 size={45} />
                            <div>
                                <Label
                                    size='medium'
                                    color='dark'
                                    align='left'
                                    weight='700'
                                    font='Roboto'
                                    padding='5px 0'
                                >
                                    Escolha um lugar.
                                </Label>
                                <Label
                                    size='nano'
                                    color='black'
                                    align='left'
                                    padding='5px 0'
                                >
                                    Inserira rapidamente as informações pessoais (nome, número
                                    de contato e endereço de e-mail) para escolher um assento.
                                </Label>
                            </div>
                        </Align>
                        <Align>
                            <BsFolderCheck size={70} />
                            <div>
                                <Label
                                    size='medium'
                                    color='dark'
                                    align='left'
                                    weight='700'
                                    font='Roboto'
                                    padding='5px 0'
                                >
                                    Gerencie os detalhes do evento e a disposição dos assentos.
                                </Label>
                                <Label
                                    size='nano'
                                    color='black'
                                    align='left'
                                    padding='5px 0'
                                >
                                    Use este aplicativo para adicionar e exibir detalhes do evento.
                                    Você também pode definir o número total de fileiras e colunas de
                                    assentos para atender às exigências do local do evento.
                                </Label>
                            </div>
                        </Align>
                        <Align>
                            <BsColumnsGap size={70} />
                            <div>
                                <Label
                                    size='medium'
                                    color='dark'
                                    align='left'
                                    weight='700'
                                    font='Roboto'
                                    padding='5px 0'
                                >
                                    Gere relatórios abrangentes.
                                </Label>
                                <Label
                                    size='nano'
                                    color='black'
                                    align='left'
                                    padding='5px 0'
                                >
                                    Você não precisa pesquisar em várias planilhas para
                                    encontrar as informações necessárias. Agrupe as informações
                                    de reservas em relatórios detalhados, classificando-as por
                                    tipo de assento (gratuito ou pago) ou status da reserva (fechada ou aberta).
                                </Label>
                            </div>
                        </Align>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <img
                            style={{ height: '350px', width: '350px', }}
                            src={events_vector}
                            alt="events"
                        />
                        <Label
                            size='medium'
                            color='dark'
                            align='left'
                            weight='700'
                            font='Roboto'
                            padding='5px 0'
                        >
                            Reserve assentos para seus clientes.
                        </Label>
                        <Label
                            size='nano'
                            color='black'
                            align='left'
                            padding='5px 0'
                        >
                            Seja para agências de viagens, cinemas ou eventos corporativos,
                            este aplicativo torna a alocação de assentos fácil e conveniente.
                        </Label>
                    </Grid>
                </Grid>
            </Container>

            {/* <Container style={{ marginTop: '40px', marginBottom: '40px' }}>
                <Label
                    size='medium'
                    color='dark'
                    align='left'
                    weight='700'
                    font='Roboto'
                    padding='0 0 20px 0'
                >
                    Dashboard
                </Label>

                <div
                    style={{
                        width: '100%',
                        height: '80vh',
                        minHeight: '600px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0'
                    }}
                >
                    <iframe
                        title="Dashboard Analytics"
                        src="https://analytics.fazendomais.net/public/dashboard/3a358a08-a6a8-4abe-9740-eb75d30ad4ee"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                        style={{
                            border: 'none'
                        }}
                    />
                </div>
            </Container> */}
        </>
    )
    return (<Sidebar current='Home' content={page} />)
}

export default Home;
